module.exports = __webpack_public_path__ + "img/bghb_img.5dedfc43.png";